import { FREE_PLAN } from '~/constants/planLimits'

/** Where a free account at its one CV goes instead: the CV list, offering the pack for more. */
export const CV_LIMIT_PATH = '/cv?upgrade=versions'

/** A `$fetch` error from adding a CV past the free plan's one (server/utils/cvLimit.ts). */
export function isCvLimitFetchError(err: unknown): boolean {
  return (err as { data?: { data?: { code?: string } } } | null)?.data?.data?.code === 'CV_LIMIT'
}

/** A Supabase insert stopped by the cv_requests trigger (supabase/migrations/20261017_free_cv_limit.sql). */
export function isCvLimitDbError(err: unknown): boolean {
  return (err as { hint?: string } | null)?.hint === 'FREE_CV_LIMIT'
}

/**
 * The free plan keeps FREE_PLAN.cvs CVs. This is the check the app makes
 * before it starts another one, so the offer comes up front instead of after a
 * failed save; the server enforces the same rule either way.
 */
export function useCvLimit() {
  const supabase = useSupabaseClient()
  const user = useSupabaseUser()
  const { isPremium, isChecked, checkPremiumStatus } = usePremiumStatus()

  async function atFreeCvLimit(): Promise<boolean> {
    if (!user.value) return false
    if (!isChecked.value) await checkPremiumStatus()
    if (isPremium.value) return false

    const { count, error } = await supabase
      .from('cv_requests')
      .select('id', { count: 'exact', head: true })
      .eq('user_id', user.value.id)
      .is('deleted_at', null)
    if (error) return false
    return (count ?? 0) >= FREE_PLAN.cvs
  }

  return { atFreeCvLimit }
}
